import { labelcommand as boardToZpl } from './label-command.js'
import { pdf as boardToPdf } from './pdf.js'
import { headlessModel } from './headless-model.js'
import { fonts } from './fonts.js'

export const BoardFunc = {
  boardToZpl,
  boardToPdf,
  headlessModel,
  fonts
}
